export const releasesData = [
  {
    id: "C3SD001",
    title: "Groove Solution",
    artist: "Slum Denizens",
    artistId: "slum-denizens",
    releaseDate: "2022-01-25",
    catalogNumber: "C2SD001",
    format: [],
    genre: ["Electronic", "Eurodance"],
    artwork: "/images/releases/groove-solution.jpg",
    description: "Influenced by early 90s Eurodance, this track was primarily made using vintage 80s/90s sound sources. The song was written during Covid lockdowns and was optimistically looking forward to everyone being able to get together and dance again.<br><br>Cubase, Korg EMX1, Korg TR Rack, Yamaha TX81Z and Roland JX8P. A Stereoping Synth Controller was used with the JX8P strings. Vocals recorded with Shure SM57 with Tonebeast TB12 preamp.",
    tracks: ["groove-solution"],
    gear: ["cubase", "emx1", "tr-rack", "tx81z", "jx8p", "stereoping", "sm57", "tb12"],
    credits: [
      { name: "Chad Wilson", role: "Music / Lyrics" },
      { name: "Sarah Wilson", role: "Vocals" },
      { name: "Jeff Goergen", role: "Cover photo" }
    ],
    streamingLinks: {
      spotify: "https://open.spotify.com/track/27Bl660LaA9MRPA8DW46qW",
      appleMusic: "https://music.apple.com/us/song/groove-solution/1605743465",
      youtube: "https://www.youtube.com/watch?v=S9XDx-FZTUE"
    },
    featured: false
  },
  {
    id: "C3SD002",
    title: "My Electric Toothbrush",
    artist: "Slum Denizens",
    artistId: "slum-denizens",
    releaseDate: "2022-08-06",
    catalogNumber: "C3SD002",
    format: [],
    genre: ["Electronic", "Electronic Funk"],
    artwork: "/images/releases/my-electric-toothbrush.jpg",
    description: "I came up with the idea for this song after returning from a trip and enjoying using my electric toothbrush for the first time in over a week. The chorus and bassline were in my head while I was brushing my teeth. I started coming up with verse lyrics while laying in bed that night.<br><br>The bassline may have been influenced by a track I had recently heard from Funk Ferret. The style is also influenced by &quot;Dirty Mutha Fuzz&quot; by Cherry Poppin' Daddies, one of my favorite bands, and also funk groups like George Clinton and Bootsie Collins.<br><br>The song was made in Cubase 11. The first part recorded was the bassline, on a Behringer 2600, modified from &quot;Classic Arp 2600 Patch&quot;. The &quot;Analog Arp&quot; riser was recorded from Yamaha Motif ES8, as were the Rhodes piano and Clav parts. The organ was emulated with Kontakt Vintage Organs library.<br><br>I used the &quot;Neo-boogie&quot; Kontakt library, and the &quot;Candlelight&quot;, &quot;Mood&quot;, &quot;Stacks&quot; and &quot;Duck&quot; kits for the drums, as well as the Wah-wah guitar from &quot;Laid Out&quot; kit, all in NI Battery. Vocals were recorded using Shure SM57. Three separate 303 lines were recorded and layered from Behringer TD-3. The vocoder part uses free VST TAL-Vocoder, and Vital was used for speech synthesis (text-to-speech).",
    tracks: ["my-electric-toothbrush"],
    gear: ["cubase", "2600", "yamaha-motif-es8", "kontakt", "battery", "td3", "sm57", "tal-vocoder", "vital"],
    credits: [
      { name: "Chad Wilson", role: "Music / Lyrics / Vocals" }
    ],
    streamingLinks: {
      appleMusic: "https://music.apple.com/us/album/my-electric-toothbrush-single/1636890858",
      spotify: "https://open.spotify.com/track/32d8XrtTf25mnrolNQ1xrX",
      youtube: "https://www.youtube.com/watch?v=wVOn3ezD-ps"
    },
    featured: true
  },
  {
    id: "C3SD003",
    title: "Madadayo",
    artist: "Slum Denizens",
    artistId: "slum-denizens",
    releaseDate: "2023-04-30",
    catalogNumber: "C3SD003",
    format: [],
    genre: ["Experimental", "Electronic"],
    artwork: "/images/releases/madadayo.jpg",
    description: "This track came together relatively quickly, while experimenting with different variations of the same base chord, in this case F#. Instead of modulating through fourths or fifths, the idea is to keep the same base note, but only alter the variation of the chord (F#M, F#m, F#sus4, etc.) The title is inspired by one of my favorite Akira Kurosawa films, as is the cover art. ",
    tracks: ["madadayo"],
    gear: ["cubase", "yamaha-motif-es8", "strymon-big-sky", "stereoping", "jx8p"],
    credits: [
      { name: "Chad Wilson", role: "Music" },
      { name: "Jack Thompson", role: "Cover art" }
    ],
    streamingLinks: {
      appleMusic: "https://music.apple.com/us/song/madadayo/1682906231",
      spotify: "https://open.spotify.com/track/7oAQ4p9wghGWBnssdgHUKL",
      youtube: "https://www.youtube.com/watch?v=UEKohgSDRaI"
    },
    featured: false
  },
  {
    id: "C3LL001A",
    title: "Coming Around Again",
    artist: "Lee & the Lips",
    artistId: "lee-and-the-lips",
    releaseDate: "2024-05-05",
    catalogNumber: "C3LL001A",
    format: [],
    genre: ["Pop", "Synthwave"],
    artwork: "/images/releases/coming-around-again.jpg",
    description: "Our cover of Carly Simon's &quot;Coming Around Again&quot;. We are going for a Julee Cruise or Chromatics vibe, something that could have been on Twin Peaks.<br><br>Sarah on vocals recorded with Sennheiser MD 421 through Tonebeast TB12. Lee on Reverend Rocco and Epiphone ES-339 electric guitars, and a Taylor acoustic. Hardware synths include Roland JX8P for strings and Behringer 2600 layered at the end. All other instruments are virtual including UAD Minimoog for bass, UAD Electra for EP, NI Battery for Linndrums and 808 crash.",
    tracks: ["coming-around-again"],
    gear: ["cubase", "md421", "rocco", "es339", "taylor", "jx8p", "2600", "uad-minimoog", "uad-electra", "battery"],
    credits: [
      { name: "Chad Wilson", role: "Production" },
      { name: "Sarah Wilson", role: "Vocals" },
      { name: "Lee Wilson", role: "Guitar" },
      { name: "Carly Simon", role: "Music / Lyrics" }
    ],
    streamingLinks: {
      appleMusic: "https://music.apple.com/us/album/coming-around-again-single/1742945109",
      spotify: "https://open.spotify.com/track/0Amh99ejKc1oyZvPgPP5Vn",
      youtube: "https://www.youtube.com/watch?v=WVHZWlPXU9I"
    },
    featured: true
  },
  {
    id: "C3LL002",
    title: "Gnossienne No. 1",
    artist: "Lee & the Lips",
    artistId: "lee-and-the-lips",
    releaseDate: "2024-06-08",
    catalogNumber: "C3LL002",
    format: [],
    genre: ["Classical"],
    artwork: "/images/releases/gnossienne-no-1.jpg",
    description: "Sarah Wilson's interpretation of Eric Satie's composition, performed on a Yamaha Motif into Kontakt's The Maverick library.",
    tracks: ["gnossienne-no-1"],
    gear: ["cubase", "kontakt", "yamaha-motif-es8"],
    streamingLinks: {
      youtube: "https://www.youtube.com/watch?v=6UlglvKk60Y"
    },
    credits: [
      { name: "Sarah Wilson", role: "Piano" },
      { name: "Chad Wilson", role: "Mixing" },
      { name: "Eric Satie", role: "Composer" }
    ],
    featured: true,
    released: true
  },
  {
    id: "C3LL003",
    title: "Seven Knots",
    artist: "Lee & the Lips",
    artistId: "lee-and-the-lips",
    releaseDate: "2026-01-04",
    catalogNumber: "C3LL003",
    format: [],
    genre: ["Rock", "Indie Rock", "Yacht Rock"],
    artwork: "/images/releases/seven-knots.jpg",
    description: "I had been wanting to try my hand at a &quot;yacht rock&quot; track for a while now. Sarah and I often watch a couple, <a href='https://www.youtube.com/@samholmessailing' target='_blank'>Sam Holmes Sailing</a> and <a href='https://www.youtube.com/@annelinsynnes' target='_blank'>Ann-Elin Synnes</a>, that sail around the world and document their adventures on YouTube. There was one video in particular where they were flying to Southeast Asia to purchase their new catamaran, which inspired me to write the lyrics (explaining why they are specifically flying business class, and the references to Langkawi and the Andaman Sea). The most common interpretation is probably that the POV character is singing about the other person, but my original intention was actually that they were singing about the boat itself, as a sort of love letter to their vessel that would take them on so many adventures, so it can be interpreted on different levels. Sarah crushed it on vocals and contributed some lyric changes as well.<br><br>The project was started in Cubase 12 and finished in Cubase 15 when I updated. Padshop was used for the pads, and various Kontakt libraries and UAD plugins were used including UAD Electro, Scarbee MM-Bass, Abbey Road 70s Drums, and Funk Guitar (Kontakt Factory Library).<br><br>Sarah took the photo we used for the album cover while we are on a trip in Mexico. ",
    tracks: ["seven-knots"],
    gear: ["cubase", "kontakt", "md421", "uad-electra", "ozone"],
    streamingLinks: {
      appleMusic: "https://music.apple.com/us/album/seven-knots-single/1864180137",
      spotify: "https://open.spotify.com/album/29OvwaR2BWwhSo2WJiaWCD",
      youtube: "https://youtu.be/wOQR7ead_N0?si=TRsM7RpQ1ZSY6hmy"
    },
    credits: [
      { name: "Chad Wilson", role: "Music/Lyrics" },
      { name: "Sarah Wilson", role: "Vocals/Artwork" }
      
    ],
    featured: true,
    released: true
  },
  {
    id: "C3P001",
    title: "Deadbeat",
    artist: "Paranoia",
    artistId: "paranoia",
    releaseDate: "2026-08-25",
    catalogNumber: "C3P001",
    format: [],
    genre: ["Hard Rock"],
    artwork: "/images/releases/deadbeat.jpg",
    description: "",
    tracks: ["deadbeat"],
    gear: ["cubase"],
    streamingLinks: {
      appleMusic: "https://music.apple.com/us/album/deadbeat-single/6800463801",
      spotify: "https://open.spotify.com/album/1aBfdXzoYDmHmJMD3FKyz2?si=Z5MAuS_5TaiDNtwLHt7Cbg",
      youtube: "https://www.youtube.com/watch?v=vuI77MutwFs"
    },
    credits: [
      { name: "Cody Redford", role: "Vocals/Guitar" },
      { name: "Rob Turpin", role: "Drums/Bass" },
      { name: "Chad Wilson", role: "Engineer/Mixing" }
    ],
    featured: true,
    released: true
  }
];